"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _getDeviceTypeByScreen = _interopRequireDefault(require("./get-device-type-by-screen"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const mobileDevices = ['phone', 'tablet'];
/**
 * Checa se o dispositivo é mobile de acordo com o tamanho da tela
 * @see getDeviceTypeByScreen
 */

var _default = () => mobileDevices.includes((0, _getDeviceTypeByScreen.default)());

exports.default = _default;